import React from 'react';
import RealEstateManagingPartnerCalendar from './RealEstateManagingPartnerCalendar';

// Simplified MainCalendar - Always renders the Real Estate Managing Partner Calendar
const MainCalendar = () => {
  return <RealEstateManagingPartnerCalendar />;
};

export default MainCalendar;
